export default __webpack_public_path__ + "static/media/forgot_password.92f80558.svg";